import ApiManager from "./ApiManager";
import { AppCache } from "./myStorage";
import config from "../config";

const helpUrl = config().HELP_URL;

export default class PartnerApi extends ApiManager {

  static async getDocProductList(params = {}) {
    try {
      if (!helpUrl) {
        console.error("helpUrl geçerli değil:", helpUrl);
        return null;
      }

      const url = new URL(helpUrl + "/admin/docProductList");
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null) url.searchParams.append(key, value);
      });
      const urlString = url.toString();

      const accessToken = AppCache.getApplicationJwt();
      const partnerToken = AppCache.getServiceJWT(503);
      const jwtToken = accessToken && partnerToken ? `${accessToken}.${partnerToken}` : "";

      const response = await fetch(urlString, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Connection-code": AppCache.getSelectedConnection()?.code || "",
          jwt: jwtToken,
        },
      });

      const text = await response.text();
      let jsonData;
      try { jsonData = JSON.parse(text); } catch(e) { jsonData = null; }

      if (jsonData?.error?.code === 1023 || jsonData?.error?.message?.includes("Expired JWT") || response.status === 401) {
        AppCache.onLoggout();
        window.location.href = "/authentication";
        return null;
      }

      if (!response.ok) {
        console.error("getDocProductList hata:", response.status, response.statusText, text);
        return null;
      }

      return jsonData;
    } catch (error) {
      console.error("getDocProductList exception:", error);
      return null;
    }
  }

  static async getDocSearchList(params = {}) {
    try {
      const url = new URL(helpUrl + "/docSearchList"); 
      url.searchParams.append("product", params.product);
      url.searchParams.append("version", params.version);
      url.searchParams.append("level", params.level || 4);
      url.searchParams.append("language", params.language || "tr");
      url.searchParams.append("status", params.status || 2);

      const accessToken = AppCache.getApplicationJwt();
      const partnerToken = AppCache.getServiceJWT(503);
      const jwtToken = accessToken && partnerToken ? `${accessToken}.${partnerToken}` : "";

      const urlString = url.toString();
      const response = await fetch(urlString, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Connection-code": AppCache.getSelectedConnection()?.code || "",
          jwt: jwtToken,
        },
      });

      const text = await response.text();
      let jsonData;
      try { jsonData = JSON.parse(text); } catch(e) { jsonData = null; }

      if (jsonData?.error?.code === 1023 || jsonData?.error?.message?.includes("Expired JWT") || response.status === 401) {
        AppCache.onLoggout();
        window.location.href = "/authentication";
        return null;
      }

      return jsonData;
    } catch (error) {
      console.error("getDocSearchList exception:", error);
      return null;
    }
  }

}
